module.exports = __webpack_public_path__ + "static/badge_nom_128-322a01094d5b5166e65026ea5cfd619e.png";